import Dashboard from "pages/Dashboard/Dashboard";
import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Navbar from "../navbar/Navbar";
import Properties from "pages/Properties/Properties";
import AddProperty from "pages/Add-Property/AddProperty";
import PropertyDashboard from "pages/Property-Dashboard/Property-Dashboard";
import TenantPaymentDashboard from "pages/Tenant-Payment-Dashboard/TenantPaymentDashboard";
import TenantManagement from "pages/Tenant-Management/TenantManagement";
import FinanceDashboard from "pages/Finances/Finance-Dashboard";

const Main = () => {
  //   const { isAuthenticated } = useAuth();

  return (
    <>
      {/* <Navbar /> */}

      <div>
        <Navbar />
        {/* nav bar goes here */}
        <Routes>
          <Route path="" element={<Navigate to="dashboard" replace />} />
          {/* Remove '/main' */}
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="add-property" element={<AddProperty />} />
          <Route path="properties" element={<Properties />} />
          <Route path="tenant-payments" element={<TenantPaymentDashboard />} />
          <Route path="tenant-management" element={<TenantManagement />} />
          <Route path="finance-dashboard" element={<FinanceDashboard />} />
          <Route
            path="property-dashboard/:propertyid"
            element={<PropertyDashboard />}
          />
        </Routes>
      </div>
    </>
  );
};

export default Main;
